const useAuthentication = () => {
    const supabase = useSupabaseClient()
    const user = useSupabaseUser()

    supabase.auth.onAuthStateChange((event, session) => {
        // console.log('DEBUG: getUser: ', supabase.auth.getUser())
        user.value = session?.user ?? null

        // if (event === 'INITIAL_SESSION') {
        //     console.log('DEBUG: Initial Session: ', user.value) // handle initial session
        // } else if (event === 'SIGNED_IN') {
        //     console.log('DEBUG: Signed In: ', user.value) // handle sign in event
        // } else if (event === 'SIGNED_OUT') {
        //     console.log('DEBUG: Signed Out: ', user.value) // handle sign out event
        // } else if (event === 'PASSWORD_RECOVERY') {
        //     console.log('DEBUG: Password Recovery: ', user.value) // handle password recovery event
        // } else if (event === 'TOKEN_REFRESHED') {
        //     console.log('DEBUG: Token Refreshed: ', user.value) // handle token refreshed event
        // } else if (event === 'USER_UPDATED') {
        //     console.log('DEBUG: User Updated: ', user.value) // handle user updated event
        // }
    })

    const signUp = async ({ email, password, captchaToken }) => {
        const { error } = await supabase.auth.signUp({
            email,
            password,
            options: {
                captchaToken: captchaToken,
                emailRedirectTo: `${window.location.origin}`
            }
        })

        if (error) {
            throw new Error(error.message)
        }
    }

    const signInAnonymously = async ({ captchaToken }) => {
        const { data, error } = await supabase.auth.signInAnonymously({
            options: {
                captchaToken: captchaToken
            }
        })

        if (error) {
            throw new Error(error.message)
        }

        return { data, error }
    }

    const signInWithEmail = async ({ email, password, captchaToken }) => {
        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
            options: {
                captchaToken: captchaToken
            }
        })

        if (error) {
            throw new Error(error.message)
        }
    }

    const signInWithOtp = async ({ email }) => {
        const { error } = await supabase.auth.signInWithOtp({
            email,
            options: {
                emailRedirectTo: `${window.location.origin}`
            }
        })

        if (error) {
            throw new Error(error.message)
        }
    }

    const signInWithOAuthProvider = async ({ provider }) => {
        const { error } = await supabase.auth.signInWithOAuth({
            provider: provider,
            options: {
                redirectTo: `${window.location.origin}`
            }
        })

        if (error) {
            throw new Error(error.message)
        }
    }

    const resetPasswordForEmail = async ({ email, captchaToken }) => {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            captchaToken: captchaToken,
            redirectTo: `${window.location.origin}/reset/password`
        })

        if (error) {
            throw new Error(error.message)
        }
    }

    const exchangeCodeForSession = async (code) => {
        const { error } = await supabase.auth.exchangeCodeForSession(code)

        if (error) {
            throw new Error(error.message)
        }
    }

    const sendPasswordReauthenticationNonce = async () => {
        const { error } = await supabase.auth.reauthenticate()

        if (error) {
            throw new Error(error.message)
        }
    }

    const updateUser = async (payload) => {
        const { error } = await supabase.auth.updateUser({
            ...payload
        })

        if (error) {
            throw new Error(error.message)
        }
    }

    const signOut = async () => {
        const { error } = await supabase.auth.signOut()

        if (error) {
            throw new Error(error.message)
        }
    }

    return {
        user,
        signUp,
        signInAnonymously,
        signInWithEmail,
        signInWithOtp,
        signInWithOAuthProvider,
        resetPasswordForEmail,
        exchangeCodeForSession,
        sendPasswordReauthenticationNonce,
        updateUser,
        signOut
    }
}

export default useAuthentication
